import { Box, CircularProgress, IconButton, Tooltip, useTheme } from "@mui/material"
import RefreshIcon from '@mui/icons-material/Refresh';
import { Property } from "csstype";

interface RefreshButtonProps {
    id?: string;
    tooltip?: string;
    loading?: boolean;
    colour?: Property.Color;
    onClick: () => void;
}

export const RefreshButton = ({
    id, tooltip, loading, colour, onClick
}: RefreshButtonProps) => {

    const theme = useTheme();

    return (
        <Tooltip title={tooltip} arrow>
            <span>
                <IconButton
                    id={id}
                    aria-label={tooltip}
                    sx={{ margin: 0, padding: '4px 10px 0 0 ', color: colour ?? theme.palette.background.paper }}
                    onClick={onClick}
                    disabled={loading}
                >
                    {loading &&
                        <Box id={`${id}-loading`} sx={{ padding: '3px' }}>
                            <CircularProgress size='28px' />
                        </Box>
                    }
                    {!loading &&
                        <RefreshIcon
                            sx={{ fontSize: '34px' }}
                        />
                    }
                </IconButton>
            </span>
        </Tooltip>
    )
}
